module.exports = __webpack_public_path__ + "img/progression.bdbe9930.png";